import { h, Component } from 'preact';

import style from '../../style/formResponse.sass';

export default class FormResponse extends Component {
  render(props) {
    const formResponseOuterContainerStyle = (props.brand === 'ruud')?style.formResponseOuterContainerRuud:style.formResponseOuterContainer;
    const formResponseInnerContainerStyle = (props.brand === 'ruud')?style.formResponseInnerContainerRuud:style.formResponseInnerContainer;
    const formResponseContentContainerStyle = (props.brand === 'ruud')?style.formResponseContentContainerRuud:style.formResponseContentContainer;
    return (
      <div className={style.formResponse}>
        <div className={formResponseOuterContainerStyle}>
          <div className={formResponseInnerContainerStyle}>
            <div className={formResponseContentContainerStyle}>
              <div dangerouslySetInnerHTML={{__html: props.modalData.html}}></div>
              <img src={props.modalData.centroBasisPixelUrl} width="1" height="1" style="position: absolute; left: -150px;" />
            </div>
            <a className={style.closeLink} onClick={props.hideModal} tabIndex="0">CLOSE</a>
          </div>
        </div>
      </div>
    );
  }
}